module.exports = __webpack_public_path__ + "static/media/Retrusion of the anterior teeth11.535a2142.png";